import { Axios } from 'cms-api'
import React from 'react'
import { getPublicLayout } from '@public/components/PublicLayout'
import { Homepage } from '@public/Homepage'
import { STRAPI_WIDGETS } from 'constants/common'

const Page = (props: any) => (
  <Homepage homepageData={props.strapiHomepageWidgets} />
)

export async function getStaticProps() {
  const strapiHomepageWidgets = await Axios.client().getHomepage({
    populate: {
      widgets: {
        on: {
          [STRAPI_WIDGETS.TRADE_ADVANTAGES_WIDGET]: {
            populate: '*',
          },
          [STRAPI_WIDGETS.HERO_WIDGET]: {
            populate: '*',
          },
          [STRAPI_WIDGETS.EXPERT_TESTIMONIALS_WIDGET]: {
            populate: {
              testimonials: {
                populate: '*',
              },
            },
          },
          [STRAPI_WIDGETS.BRANDS_WIDGET]: {
            populate: {
              brands: {
                populate: '*',
              },
            },
          },
          [STRAPI_WIDGETS.FEATURED_EXPERTS_WIDGET]: {
            populate: {
              experts: {
                populate: '*',
              },
            },
          },
          [STRAPI_WIDGETS.TRENDING_PRODUCTS_WIDGET]: {
            populate: {
              products: {
                populate: {
                  product: {
                    populate: {
                      images: true,
                      productVariants: {
                        populate: {
                          images: true,
                          leadProductImage: true,
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          [STRAPI_WIDGETS.FEATURED_CATEGORIES_WIDGET]: {
            populate: {
              categories: {
                populate: '*',
              },
            },
          },
        },
      },
    } as never,
  })

  const combinedProps = {
    props: { strapiHomepageWidgets },
    revalidate: 600,
  }

  return combinedProps
}

Page.getLayout = (page: React.ReactElement) =>
  getPublicLayout(page, { isFullWidth: true })

export default Page
